// @flow

import { connect } from "react-redux";
import UpdatePanel from "./view";
import { showDialog } from "../state/context/actions";

export default connect(
    state => ({
        session: state.context.sessionInfo,
        userInfo: state.context.userInfo
    }),
    dispatch => ({
        onShowPlotMap: () => dispatch(showDialog("PlotMap")),
        onShowWriteJournal: () => dispatch(showDialog("WriteJournal"))
    })
)(UpdatePanel);



// WEBPACK FOOTER //
// ./src/update-panel/index.js